/**
 * Task utility functions
 */

/**
 * Format date string to YYYY-MM-DD format
 * @param {string} dateString - Date string to format
 * @returns {string} Formatted date string
 */
export function formatDateTask(dateString) {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}

/**
 * Check if a task is outdated based on notification lead time
 * @param {string} taskDate - Task date
 * @param {number} interval - Notification lead time in days
 * @returns {boolean} True if task is outdated
 */
export function isTaskOutdated(taskDate, interval) {
  const currentDate = new Date();
  const taskUpdatedAt = new Date(taskDate);
  taskUpdatedAt.setDate(taskUpdatedAt.getDate() - interval);
  return taskUpdatedAt < currentDate;
}

/**
 * Get human-readable interval text
 * @param {string} intervalType - Type of interval
 * @param {number} intervalValue - Value of interval
 * @param {Array} intervals - Available intervals array from constants
 * @returns {string} Human-readable interval text
 */
export function intervalText(intervalType, intervalValue, intervals) {
  const findInterval = intervals.find(
    (interval) => interval.value.type === intervalType && interval.value.value === intervalValue
  );
  return findInterval?.period || '';
}

/**
 * Check if task was completed on time
 * @param {string} updatedAt - Task update date
 * @param {string} createdAt - Task creation date
 * @param {string} maintenanceName - Maintenance task name
 * @returns {boolean|null} True if on time, false if late, null if not applicable
 */
export function isTaskCompletedOnTime(updatedAt, createdAt, maintenanceName) {
  if (maintenanceName === 'Report a repair') {
    return null;
  }
  const updatedDate = new Date(updatedAt);
  const createdDate = new Date(createdAt);
  return updatedDate <= createdDate;
}